import React, { useContext, useState } from 'react'
import cn from 'classnames'
import { Button, ButtonStyles, Typography } from '@grammarly/badger-ui'
import { Document } from '@contentful/rich-text-types'
import { InterfaceCopy } from '@dsk/core/icons'

import { gnarSpec } from '../../../../lib/tracking/gnar'
import { PageContext } from '../../../../contexts/page-context'
import { renderRichTextSingleLineContent } from '../../../renderer/rich-text'

import styles from './output.module.scss'
import { FULLSTORY_MASK_CLASSNAME } from '../../../../lib/tracking/fullstory/constants'
import { useIntl } from 'react-intl'

const { T3, C4 } = Typography

interface OutputProps {
  output: string
  label: Document
  description: Document
}

export const Output: React.FC<OutputProps> = ({ output, label, description }) => {
  const intl = useIntl()
  const copyText = intl.formatMessage({
    id: 'global.uiAction.copy',
    description: 'Text for CTA that prompts user to copy an element',
    defaultMessage: 'Copy',
  })
  const clipboardCopiedText = intl.formatMessage({
    id: 'global.uiNotification.copied',
    description: 'Text that lets user know a value was copied to the clipboard',
    defaultMessage: 'Copied to clipboard!',
  })

  const { pageId, slug } = useContext(PageContext)
  const [copyBtnText, setCopyBtnText] = useState(copyText)

  const copy = () => {
    gnarSpec.goToolsCtaClick('copy', pageId, slug)

    setCopyBtnText(clipboardCopiedText)
    void navigator?.clipboard.writeText(output)
    setTimeout(() => setCopyBtnText(copyText), 2000)
  }

  return (
    <div className={styles.outputContainer}>
      <T3 as="h3">{renderRichTextSingleLineContent(label)}</T3>
      <C4 as="div">{renderRichTextSingleLineContent(description)}</C4>
      <C4 as="div" className={cn(FULLSTORY_MASK_CLASSNAME, styles.outputText)}>
        {output}
      </C4>
      <Button
        className={cn(ButtonStyles.BlueButtonWhiteText, styles.copyButton)}
        onClick={copy}
        iconLeft={<InterfaceCopy className={styles.copyIcon} />}
      >
        {copyBtnText}
      </Button>
    </div>
  )
}
